export const SocialClearancesAnimation = {
  nm: "07",
  h: 281,
  w: 281,
  meta: { g: "LottieFiles Figma v92" },
  layers: [
    {
      ty: 4,
      nm: "Group 2708",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [63, 64], t: 0 },
            { s: [70.83, 71.74], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [141, 106] },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [45], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Group 2707",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [63, 64], t: 0 },
            { s: [70.83, 71.74], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [63, 64], t: 0 },
            { s: [70.83, 71.74], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 2,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0.81, 4.87] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [63, 100.66],
              t: 0,
            },
            { s: [70.83, 108.4], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.615, 9.736],
                      [0, 9.736],
                      [0, 6.491],
                      [1.615, 6.491],
                      [1.615, 9.736],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.61, 9.74],
                      [0, 9.74],
                      [0, 6.49],
                      [1.61, 6.49],
                      [1.61, 9.74],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.615, 3.245],
                      [0, 3.245],
                      [0, 0],
                      [1.615, 0],
                      [1.615, 3.245],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.61, 3.25],
                      [0, 3.25],
                      [0, 0],
                      [1.61, 0],
                      [1.61, 3.25],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 3,
      parent: 2,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0.81, 4.87] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [63, 30.28],
              t: 0,
            },
            { s: [70.83, 38.02], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.615, 9.736],
                      [0, 9.736],
                      [0, 6.491],
                      [1.615, 6.491],
                      [1.615, 9.736],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.61, 9.74],
                      [0, 9.74],
                      [0, 6.49],
                      [1.61, 6.49],
                      [1.61, 9.74],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.615, 3.245],
                      [0, 3.245],
                      [0, 0],
                      [1.615, 0],
                      [1.615, 3.245],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.61, 3.25],
                      [0, 3.25],
                      [0, 0],
                      [1.61, 0],
                      [1.61, 3.25],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 4,
      parent: 2,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [6.65, 0.81] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [27.64, 64],
              t: 0,
            },
            { s: [35.47, 71.74], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.307, 1.623],
                      [10.078, 1.623],
                      [10.078, 0],
                      [13.307, 0],
                      [13.307, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.31, 1.62],
                      [10.08, 1.62],
                      [10.08, 0],
                      [13.31, 0],
                      [13.31, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.848, 1.623],
                      [3.619, 1.623],
                      [3.619, 0],
                      [6.848, 0],
                      [6.848, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.85, 1.62],
                      [3.62, 1.62],
                      [3.62, 0],
                      [6.85, 0],
                      [6.85, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0.389, 1.623],
                      [0, 1.623],
                      [0, 0],
                      [0.389, 0],
                      [0.389, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0.39, 1.62],
                      [0, 1.62],
                      [0, 0],
                      [0.39, 0],
                      [0.39, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 5,
      parent: 2,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [6.65, 0.81] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [98.36, 64],
              t: 0,
            },
            { s: [106.19, 71.74], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.307, 1.623],
                      [10.078, 1.623],
                      [10.078, 0],
                      [13.307, 0],
                      [13.307, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.31, 1.62],
                      [10.08, 1.62],
                      [10.08, 0],
                      [13.31, 0],
                      [13.31, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.848, 1.623],
                      [3.619, 1.623],
                      [3.619, 0],
                      [6.848, 0],
                      [6.848, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.85, 1.62],
                      [3.62, 1.62],
                      [3.62, 0],
                      [6.85, 0],
                      [6.85, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0.389, 1.623],
                      [0, 1.623],
                      [0, 0],
                      [0.389, 0],
                      [0.389, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0.39, 1.62],
                      [0, 1.62],
                      [0, 0],
                      [0.39, 0],
                      [0.39, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 6,
      parent: 2,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [8.02, 0.81] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [88.91, 37.27],
              t: 0,
            },
            { s: [96.74, 45.01], t: 75 },
          ],
        },
        r: { a: 0, k: -45.14 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.043, 0],
                      [0, 0],
                      [0, 1.619],
                      [16.043, 1.619],
                      [16.043, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.04, 0],
                      [0, 0],
                      [0, 1.62],
                      [16.04, 1.62],
                      [16.04, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 7,
      parent: 2,
    },
    {
      ty: 4,
      nm: "Group",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.78, 60.37] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [63, 64], t: 0 },
            { s: [70.83, 71.74], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 8,
      parent: 2,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.78, 9.83] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [9.78, 110.92] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 5.418],
                      [-5.391, 0],
                      [0, -5.418],
                      [5.391, 0],
                    ],
                    o: [
                      [-5.391, 0],
                      [0, -5.418],
                      [5.391, 0],
                      [0, 5.418],
                      [0, 0],
                    ],
                    v: [
                      [9.778, 19.652],
                      [0, 9.826],
                      [9.778, 0],
                      [19.556, 9.826],
                      [9.778, 19.652],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 5.42],
                      [-5.39, 0],
                      [0, -5.42],
                      [5.39, 0],
                    ],
                    o: [
                      [-5.39, 0],
                      [0, -5.42],
                      [5.39, 0],
                      [0, 5.42],
                      [0, 0],
                    ],
                    v: [
                      [9.78, 19.65],
                      [0, 9.83],
                      [9.78, 0],
                      [19.56, 9.83],
                      [9.78, 19.65],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -4.524],
                      [-4.502, 0],
                      [0, 4.524],
                      [4.502, 0],
                    ],
                    o: [
                      [-4.502, 0],
                      [0, 4.524],
                      [4.502, 0],
                      [0, -4.524],
                      [0, 0],
                    ],
                    v: [
                      [9.778, 1.623],
                      [1.615, 9.826],
                      [9.778, 18.03],
                      [17.942, 9.826],
                      [9.778, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -4.52],
                      [-4.5, 0],
                      [0, 4.52],
                      [4.5, 0],
                    ],
                    o: [
                      [-4.5, 0],
                      [0, 4.52],
                      [4.5, 0],
                      [0, -4.52],
                      [0, 0],
                    ],
                    v: [
                      [9.78, 1.62],
                      [1.61, 9.83],
                      [9.78, 18.03],
                      [17.94, 9.83],
                      [9.78, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 9,
      parent: 8,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.78, 9.83] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [9.78, 9.83] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 5.418],
                      [-5.391, 0],
                      [0, -5.418],
                      [5.391, 0],
                    ],
                    o: [
                      [-5.391, 0],
                      [0, -5.418],
                      [5.391, 0],
                      [0, 5.418],
                      [0, 0],
                    ],
                    v: [
                      [9.778, 19.652],
                      [0, 9.826],
                      [9.778, 0],
                      [19.556, 9.826],
                      [9.778, 19.652],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 5.42],
                      [-5.39, 0],
                      [0, -5.42],
                      [5.39, 0],
                    ],
                    o: [
                      [-5.39, 0],
                      [0, -5.42],
                      [5.39, 0],
                      [0, 5.42],
                      [0, 0],
                    ],
                    v: [
                      [9.78, 19.65],
                      [0, 9.83],
                      [9.78, 0],
                      [19.56, 9.83],
                      [9.78, 19.65],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -4.524],
                      [-4.502, 0],
                      [0, 4.524],
                      [4.502, 0],
                    ],
                    o: [
                      [-4.502, 0],
                      [0, 4.524],
                      [4.502, 0],
                      [0, -4.524],
                      [0, 0],
                    ],
                    v: [
                      [9.778, 1.623],
                      [1.615, 9.826],
                      [9.778, 18.03],
                      [17.942, 9.826],
                      [9.778, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -4.52],
                      [-4.5, 0],
                      [0, 4.52],
                      [4.5, 0],
                    ],
                    o: [
                      [-4.5, 0],
                      [0, 4.52],
                      [4.5, 0],
                      [0, -4.52],
                      [0, 0],
                    ],
                    v: [
                      [9.78, 1.62],
                      [1.61, 9.83],
                      [9.78, 18.03],
                      [17.94, 9.83],
                      [9.78, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 10,
      parent: 8,
    },
    {
      ty: 4,
      nm: "Group",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [60.76, 9.83] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [63, 64], t: 0 },
            { s: [70.83, 71.74], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 11,
      parent: 2,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.78, 9.83] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [111.75, 9.83] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 5.418],
                      [-5.391, 0],
                      [0, -5.418],
                      [5.391, 0],
                    ],
                    o: [
                      [-5.391, 0],
                      [0, -5.418],
                      [5.391, 0],
                      [0, 5.418],
                      [0, 0],
                    ],
                    v: [
                      [9.778, 19.652],
                      [0, 9.826],
                      [9.778, 0],
                      [19.556, 9.826],
                      [9.778, 19.652],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 5.42],
                      [-5.39, 0],
                      [0, -5.42],
                      [5.39, 0],
                    ],
                    o: [
                      [-5.39, 0],
                      [0, -5.42],
                      [5.39, 0],
                      [0, 5.42],
                      [0, 0],
                    ],
                    v: [
                      [9.78, 19.65],
                      [0, 9.83],
                      [9.78, 0],
                      [19.56, 9.83],
                      [9.78, 19.65],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -4.524],
                      [-4.502, 0],
                      [0, 4.524],
                      [4.502, 0],
                    ],
                    o: [
                      [-4.502, 0],
                      [0, 4.524],
                      [4.502, 0],
                      [0, -4.524],
                      [0, 0],
                    ],
                    v: [
                      [9.778, 1.623],
                      [1.615, 9.826],
                      [9.778, 18.03],
                      [17.942, 9.826],
                      [9.778, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -4.52],
                      [-4.5, 0],
                      [0, 4.52],
                      [4.5, 0],
                    ],
                    o: [
                      [-4.5, 0],
                      [0, 4.52],
                      [4.5, 0],
                      [0, -4.52],
                      [0, 0],
                    ],
                    v: [
                      [9.78, 1.62],
                      [1.61, 9.83],
                      [9.78, 18.03],
                      [17.94, 9.83],
                      [9.78, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 12,
      parent: 11,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.78, 9.83] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [9.78, 9.83] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 5.418],
                      [-5.391, 0],
                      [0, -5.418],
                      [5.391, 0],
                    ],
                    o: [
                      [-5.391, 0],
                      [0, -5.418],
                      [5.391, 0],
                      [0, 5.418],
                      [0, 0],
                    ],
                    v: [
                      [9.778, 19.652],
                      [0, 9.826],
                      [9.778, 0],
                      [19.556, 9.826],
                      [9.778, 19.652],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 5.42],
                      [-5.39, 0],
                      [0, -5.42],
                      [5.39, 0],
                    ],
                    o: [
                      [-5.39, 0],
                      [0, -5.42],
                      [5.39, 0],
                      [0, 5.42],
                      [0, 0],
                    ],
                    v: [
                      [9.78, 19.65],
                      [0, 9.83],
                      [9.78, 0],
                      [19.56, 9.83],
                      [9.78, 19.65],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -4.524],
                      [-4.502, 0],
                      [0, 4.524],
                      [4.502, 0],
                    ],
                    o: [
                      [-4.502, 0],
                      [0, 4.524],
                      [4.502, 0],
                      [0, -4.524],
                      [0, 0],
                    ],
                    v: [
                      [9.778, 1.623],
                      [1.615, 9.826],
                      [9.778, 18.03],
                      [17.942, 9.826],
                      [9.778, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -4.52],
                      [-4.5, 0],
                      [0, 4.52],
                      [4.5, 0],
                    ],
                    o: [
                      [-4.5, 0],
                      [0, 4.52],
                      [4.5, 0],
                      [0, -4.52],
                      [0, 0],
                    ],
                    v: [
                      [9.78, 1.62],
                      [1.61, 9.83],
                      [9.78, 18.03],
                      [17.94, 9.83],
                      [9.78, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 13,
      parent: 11,
    },
    {
      ty: 4,
      nm: "Group 2706",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [63, 64], t: 0 },
            { s: [70.83, 71.74], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [63, 64], t: 0 },
            { s: [70.83, 71.74], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 14,
      parent: 2,
    },
    {
      ty: 4,
      nm: "Group",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [18.75, 18.84] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [18.75, 109.16],
              t: 0,
            },
            { s: [26.58, 116.9], t: 75 },
          ],
        },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [-45], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 15,
      parent: 14,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [13.57, 4.18] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 28.09] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [4.968, 0],
                      [2.675, -4.221],
                      [0, 0],
                      [-5.522, 0],
                      [-2.975, -4.691],
                      [0, 0],
                    ],
                    o: [
                      [-2.675, -4.221],
                      [-4.968, 0],
                      [0, 0],
                      [2.973, -4.691],
                      [5.522, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [25.777, 8.362],
                      [13.569, 1.621],
                      [1.362, 8.362],
                      [0, 7.491],
                      [13.569, 0],
                      [27.138, 7.491],
                      [25.777, 8.362],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [4.97, 0],
                      [2.68, -4.22],
                      [0, 0],
                      [-5.52, 0],
                      [-2.97, -4.69],
                      [0, 0],
                    ],
                    o: [
                      [-2.67, -4.22],
                      [-4.97, 0],
                      [0, 0],
                      [2.97, -4.69],
                      [5.52, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [25.78, 8.36],
                      [13.57, 1.62],
                      [1.36, 8.36],
                      [0, 7.49],
                      [13.57, 0],
                      [27.14, 7.49],
                      [25.78, 8.36],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 16,
      parent: 15,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [8.44, 8.49] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 17.03] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 4.681],
                      [-4.658, 0],
                      [0, -4.679],
                      [4.656, 0],
                    ],
                    o: [
                      [-4.656, 0],
                      [0, -4.68],
                      [4.658, 0],
                      [0, 4.679],
                      [0, 0],
                    ],
                    v: [
                      [8.445, 16.971],
                      [0, 8.485],
                      [8.445, 0],
                      [16.888, 8.485],
                      [8.445, 16.971],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 4.68],
                      [-4.66, 0],
                      [0, -4.68],
                      [4.66, 0],
                    ],
                    o: [
                      [-4.66, 0],
                      [0, -4.68],
                      [4.66, 0],
                      [0, 4.68],
                      [0, 0],
                    ],
                    v: [
                      [8.45, 16.97],
                      [0, 8.48],
                      [8.45, 0],
                      [16.89, 8.48],
                      [8.45, 16.97],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -3.783],
                      [-3.766, 0],
                      [0, 3.784],
                      [3.764, 0],
                    ],
                    o: [
                      [-3.766, 0],
                      [0, 3.783],
                      [3.766, 0],
                      [0, -3.784],
                      [0, 0],
                    ],
                    v: [
                      [8.445, 1.623],
                      [1.615, 8.485],
                      [8.445, 15.349],
                      [15.274, 8.485],
                      [8.445, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -3.78],
                      [-3.77, 0],
                      [0, 3.78],
                      [3.76, 0],
                    ],
                    o: [
                      [-3.77, 0],
                      [0, 3.78],
                      [3.77, 0],
                      [0, -3.78],
                      [0, 0],
                    ],
                    v: [
                      [8.45, 1.62],
                      [1.61, 8.48],
                      [8.45, 15.35],
                      [15.27, 8.48],
                      [8.45, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 17,
      parent: 15,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [18.75, 18.84] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 18.84] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 10.389],
                      [-10.338, 0],
                      [0, -10.389],
                      [10.338, 0],
                    ],
                    o: [
                      [-10.338, 0],
                      [0, -10.389],
                      [10.338, 0],
                      [0, 10.389],
                      [0, 0],
                    ],
                    v: [
                      [18.749, 37.682],
                      [0, 18.841],
                      [18.749, 0],
                      [37.498, 18.841],
                      [18.749, 37.682],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 10.39],
                      [-10.34, 0],
                      [0, -10.39],
                      [10.34, 0],
                    ],
                    o: [
                      [-10.34, 0],
                      [0, -10.39],
                      [10.34, 0],
                      [0, 10.39],
                      [0, 0],
                    ],
                    v: [
                      [18.75, 37.68],
                      [0, 18.84],
                      [18.75, 0],
                      [37.5, 18.84],
                      [18.75, 37.68],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -9.494],
                      [-9.448, 0],
                      [0, 9.494],
                      [9.448, 0],
                    ],
                    o: [
                      [-9.448, 0],
                      [0, 9.494],
                      [9.448, 0],
                      [0, -9.494],
                      [0, 0],
                    ],
                    v: [
                      [18.749, 1.623],
                      [1.615, 18.841],
                      [18.749, 36.059],
                      [35.883, 18.841],
                      [18.749, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -9.49],
                      [-9.45, 0],
                      [0, 9.49],
                      [9.45, 0],
                    ],
                    o: [
                      [-9.45, 0],
                      [0, 9.49],
                      [9.45, 0],
                      [0, -9.49],
                      [0, 0],
                    ],
                    v: [
                      [18.75, 1.62],
                      [1.61, 18.84],
                      [18.75, 36.06],
                      [35.88, 18.84],
                      [18.75, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 18,
      parent: 15,
    },
    {
      ty: 4,
      nm: "Group",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [18.75, 18.84] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [18.75, 18.84],
              t: 0,
            },
            { s: [26.58, 26.58], t: 75 },
          ],
        },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [-45], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 19,
      parent: 14,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [13.57, 4.18] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 28.09] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [4.968, 0],
                      [2.675, -4.221],
                      [0, 0],
                      [-5.522, 0],
                      [-2.973, -4.691],
                      [0, 0],
                    ],
                    o: [
                      [-2.675, -4.221],
                      [-4.968, 0],
                      [0, 0],
                      [2.973, -4.691],
                      [5.522, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [25.777, 8.362],
                      [13.569, 1.621],
                      [1.362, 8.362],
                      [0, 7.491],
                      [13.569, 0],
                      [27.138, 7.491],
                      [25.777, 8.362],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [4.97, 0],
                      [2.68, -4.22],
                      [0, 0],
                      [-5.52, 0],
                      [-2.97, -4.69],
                      [0, 0],
                    ],
                    o: [
                      [-2.67, -4.22],
                      [-4.97, 0],
                      [0, 0],
                      [2.97, -4.69],
                      [5.52, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [25.78, 8.36],
                      [13.57, 1.62],
                      [1.36, 8.36],
                      [0, 7.49],
                      [13.57, 0],
                      [27.14, 7.49],
                      [25.78, 8.36],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 20,
      parent: 19,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [8.44, 8.48] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 17.03] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 4.679],
                      [-4.658, 0],
                      [0, -4.679],
                      [4.656, 0],
                    ],
                    o: [
                      [-4.656, 0],
                      [0, -4.679],
                      [4.658, 0],
                      [0, 4.679],
                      [0, 0],
                    ],
                    v: [
                      [8.445, 16.97],
                      [0, 8.485],
                      [8.445, 0],
                      [16.888, 8.485],
                      [8.445, 16.97],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 4.68],
                      [-4.66, 0],
                      [0, -4.68],
                      [4.66, 0],
                    ],
                    o: [
                      [-4.66, 0],
                      [0, -4.68],
                      [4.66, 0],
                      [0, 4.68],
                      [0, 0],
                    ],
                    v: [
                      [8.45, 16.97],
                      [0, 8.48],
                      [8.45, 0],
                      [16.89, 8.48],
                      [8.45, 16.97],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -3.783],
                      [-3.766, 0],
                      [0, 3.783],
                      [3.764, 0],
                    ],
                    o: [
                      [-3.766, 0],
                      [0, 3.783],
                      [3.766, 0],
                      [0, -3.783],
                      [0, 0],
                    ],
                    v: [
                      [8.445, 1.621],
                      [1.615, 8.483],
                      [8.445, 15.345],
                      [15.274, 8.483],
                      [8.445, 1.621],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -3.78],
                      [-3.77, 0],
                      [0, 3.78],
                      [3.76, 0],
                    ],
                    o: [
                      [-3.77, 0],
                      [0, 3.78],
                      [3.77, 0],
                      [0, -3.78],
                      [0, 0],
                    ],
                    v: [
                      [8.45, 1.62],
                      [1.61, 8.48],
                      [8.45, 15.35],
                      [15.27, 8.48],
                      [8.45, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 21,
      parent: 19,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [18.75, 18.84] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 18.84] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 10.389],
                      [-10.338, 0],
                      [0, -10.389],
                      [10.338, 0],
                    ],
                    o: [
                      [-10.338, 0],
                      [0, -10.389],
                      [10.338, 0],
                      [0, 10.389],
                      [0, 0],
                    ],
                    v: [
                      [18.749, 37.682],
                      [0, 18.841],
                      [18.749, 0],
                      [37.498, 18.841],
                      [18.749, 37.682],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 10.39],
                      [-10.34, 0],
                      [0, -10.39],
                      [10.34, 0],
                    ],
                    o: [
                      [-10.34, 0],
                      [0, -10.39],
                      [10.34, 0],
                      [0, 10.39],
                      [0, 0],
                    ],
                    v: [
                      [18.75, 37.68],
                      [0, 18.84],
                      [18.75, 0],
                      [37.5, 18.84],
                      [18.75, 37.68],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -9.494],
                      [-9.448, 0],
                      [0, 9.494],
                      [9.448, 0],
                    ],
                    o: [
                      [-9.448, 0],
                      [0, 9.494],
                      [9.448, 0],
                      [0, -9.494],
                      [0, 0],
                    ],
                    v: [
                      [18.749, 1.623],
                      [1.615, 18.841],
                      [18.749, 36.059],
                      [35.883, 18.841],
                      [18.749, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -9.49],
                      [-9.45, 0],
                      [0, 9.49],
                      [9.45, 0],
                    ],
                    o: [
                      [-9.45, 0],
                      [0, 9.49],
                      [9.45, 0],
                      [0, -9.49],
                      [0, 0],
                    ],
                    v: [
                      [18.75, 1.62],
                      [1.61, 18.84],
                      [18.75, 36.06],
                      [35.88, 18.84],
                      [18.75, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 22,
      parent: 19,
    },
    {
      ty: 4,
      nm: "Group",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [18.75, 18.84] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [107.25, 18.84],
              t: 0,
            },
            { s: [115.08, 26.58], t: 75 },
          ],
        },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [-45], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 23,
      parent: 14,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [13.57, 4.18] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 28.09] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-5.522, 0],
                      [-2.973, -4.691],
                      [0, 0],
                      [4.968, 0],
                      [2.675, -4.221],
                    ],
                    o: [
                      [0, 0],
                      [2.973, -4.691],
                      [5.522, 0],
                      [0, 0],
                      [-2.675, -4.221],
                      [-4.968, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.362, 8.362],
                      [0, 7.491],
                      [13.569, 0],
                      [27.138, 7.491],
                      [25.777, 8.362],
                      [13.569, 1.621],
                      [1.362, 8.362],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-5.52, 0],
                      [-2.97, -4.69],
                      [0, 0],
                      [4.97, 0],
                      [2.68, -4.22],
                    ],
                    o: [
                      [0, 0],
                      [2.97, -4.69],
                      [5.52, 0],
                      [0, 0],
                      [-2.67, -4.22],
                      [-4.97, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.36, 8.36],
                      [0, 7.49],
                      [13.57, 0],
                      [27.14, 7.49],
                      [25.78, 8.36],
                      [13.57, 1.62],
                      [1.36, 8.36],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 24,
      parent: 23,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [8.44, 8.48] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 17.03] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 4.679],
                      [-4.656, 0],
                      [0, -4.679],
                      [4.658, 0],
                    ],
                    o: [
                      [-4.656, 0],
                      [0, -4.679],
                      [4.656, 0],
                      [0, 4.679],
                      [0, 0],
                    ],
                    v: [
                      [8.443, 16.97],
                      [0, 8.485],
                      [8.443, 0],
                      [16.888, 8.485],
                      [8.443, 16.97],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 4.68],
                      [-4.66, 0],
                      [0, -4.68],
                      [4.66, 0],
                    ],
                    o: [
                      [-4.66, 0],
                      [0, -4.68],
                      [4.66, 0],
                      [0, 4.68],
                      [0, 0],
                    ],
                    v: [
                      [8.44, 16.97],
                      [0, 8.48],
                      [8.44, 0],
                      [16.89, 8.48],
                      [8.44, 16.97],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -3.783],
                      [-3.764, 0],
                      [0, 3.783],
                      [3.766, 0],
                    ],
                    o: [
                      [-3.766, 0],
                      [0, 3.783],
                      [3.764, 0],
                      [0, -3.783],
                      [0, 0],
                    ],
                    v: [
                      [8.443, 1.621],
                      [1.615, 8.483],
                      [8.443, 15.345],
                      [15.274, 8.483],
                      [8.443, 1.621],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -3.78],
                      [-3.76, 0],
                      [0, 3.78],
                      [3.77, 0],
                    ],
                    o: [
                      [-3.77, 0],
                      [0, 3.78],
                      [3.76, 0],
                      [0, -3.78],
                      [0, 0],
                    ],
                    v: [
                      [8.44, 1.62],
                      [1.61, 8.48],
                      [8.44, 15.35],
                      [15.27, 8.48],
                      [8.44, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 25,
      parent: 23,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [18.75, 18.84] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 18.84] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 10.389],
                      [-10.34, 0],
                      [0, -10.389],
                      [10.338, 0],
                    ],
                    o: [
                      [-10.338, 0],
                      [0, -10.389],
                      [10.34, 0],
                      [0, 10.389],
                      [0, 0],
                    ],
                    v: [
                      [18.749, 37.682],
                      [0, 18.841],
                      [18.749, 0],
                      [37.498, 18.841],
                      [18.749, 37.682],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 10.39],
                      [-10.34, 0],
                      [0, -10.39],
                      [10.34, 0],
                    ],
                    o: [
                      [-10.34, 0],
                      [0, -10.39],
                      [10.34, 0],
                      [0, 10.39],
                      [0, 0],
                    ],
                    v: [
                      [18.75, 37.68],
                      [0, 18.84],
                      [18.75, 0],
                      [37.5, 18.84],
                      [18.75, 37.68],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -9.494],
                      [-9.448, 0],
                      [0, 9.494],
                      [9.448, 0],
                    ],
                    o: [
                      [-9.448, 0],
                      [0, 9.494],
                      [9.448, 0],
                      [0, -9.494],
                      [0, 0],
                    ],
                    v: [
                      [18.749, 1.623],
                      [1.615, 18.841],
                      [18.749, 36.059],
                      [35.883, 18.841],
                      [18.749, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -9.49],
                      [-9.45, 0],
                      [0, 9.49],
                      [9.45, 0],
                    ],
                    o: [
                      [-9.45, 0],
                      [0, 9.49],
                      [9.45, 0],
                      [0, -9.49],
                      [0, 0],
                    ],
                    v: [
                      [18.75, 1.62],
                      [1.61, 18.84],
                      [18.75, 36.06],
                      [35.88, 18.84],
                      [18.75, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 26,
      parent: 23,
    },
    {
      ty: 4,
      nm: "Group",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [18.75, 18.84] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [107.25, 109.16],
              t: 0,
            },
            { s: [115.08, 116.9], t: 75 },
          ],
        },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [-45], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 27,
      parent: 14,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [13.57, 4.18] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 28.09] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-5.522, 0],
                      [-2.973, -4.691],
                      [0, 0],
                      [4.968, 0],
                      [2.677, -4.221],
                    ],
                    o: [
                      [0, 0],
                      [2.973, -4.691],
                      [5.522, 0],
                      [0, 0],
                      [-2.675, -4.221],
                      [-4.968, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.362, 8.362],
                      [0, 7.491],
                      [13.569, 0],
                      [27.138, 7.491],
                      [25.777, 8.362],
                      [13.569, 1.621],
                      [1.362, 8.362],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-5.52, 0],
                      [-2.97, -4.69],
                      [0, 0],
                      [4.97, 0],
                      [2.68, -4.22],
                    ],
                    o: [
                      [0, 0],
                      [2.97, -4.69],
                      [5.52, 0],
                      [0, 0],
                      [-2.67, -4.22],
                      [-4.97, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.36, 8.36],
                      [0, 7.49],
                      [13.57, 0],
                      [27.14, 7.49],
                      [25.78, 8.36],
                      [13.57, 1.62],
                      [1.36, 8.36],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 28,
      parent: 27,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [8.44, 8.49] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 17.03] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 4.681],
                      [-4.656, 0],
                      [0, -4.679],
                      [4.658, 0],
                    ],
                    o: [
                      [-4.656, 0],
                      [0, -4.68],
                      [4.656, 0],
                      [0, 4.679],
                      [0, 0],
                    ],
                    v: [
                      [8.443, 16.971],
                      [0, 8.485],
                      [8.443, 0],
                      [16.888, 8.485],
                      [8.443, 16.971],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 4.68],
                      [-4.66, 0],
                      [0, -4.68],
                      [4.66, 0],
                    ],
                    o: [
                      [-4.66, 0],
                      [0, -4.68],
                      [4.66, 0],
                      [0, 4.68],
                      [0, 0],
                    ],
                    v: [
                      [8.44, 16.97],
                      [0, 8.48],
                      [8.44, 0],
                      [16.89, 8.48],
                      [8.44, 16.97],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -3.783],
                      [-3.764, 0],
                      [0, 3.784],
                      [3.766, 0],
                    ],
                    o: [
                      [-3.766, 0],
                      [0, 3.783],
                      [3.764, 0],
                      [0, -3.784],
                      [0, 0],
                    ],
                    v: [
                      [8.443, 1.623],
                      [1.615, 8.485],
                      [8.443, 15.349],
                      [15.274, 8.485],
                      [8.443, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -3.78],
                      [-3.76, 0],
                      [0, 3.78],
                      [3.77, 0],
                    ],
                    o: [
                      [-3.77, 0],
                      [0, 3.78],
                      [3.76, 0],
                      [0, -3.78],
                      [0, 0],
                    ],
                    v: [
                      [8.44, 1.62],
                      [1.61, 8.48],
                      [8.44, 15.35],
                      [15.27, 8.48],
                      [8.44, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 29,
      parent: 27,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [18.75, 18.84] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [18.75, 18.84] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 10.389],
                      [-10.338, 0],
                      [0, -10.389],
                      [10.338, 0],
                    ],
                    o: [
                      [-10.338, 0],
                      [0, -10.389],
                      [10.338, 0],
                      [0, 10.389],
                      [0, 0],
                    ],
                    v: [
                      [18.749, 37.682],
                      [0, 18.841],
                      [18.749, 0],
                      [37.498, 18.841],
                      [18.749, 37.682],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 10.39],
                      [-10.34, 0],
                      [0, -10.39],
                      [10.34, 0],
                    ],
                    o: [
                      [-10.34, 0],
                      [0, -10.39],
                      [10.34, 0],
                      [0, 10.39],
                      [0, 0],
                    ],
                    v: [
                      [18.75, 37.68],
                      [0, 18.84],
                      [18.75, 0],
                      [37.5, 18.84],
                      [18.75, 37.68],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -9.494],
                      [-9.448, 0],
                      [0, 9.494],
                      [9.448, 0],
                    ],
                    o: [
                      [-9.448, 0],
                      [0, 9.494],
                      [9.448, 0],
                      [0, -9.494],
                      [0, 0],
                    ],
                    v: [
                      [18.749, 1.623],
                      [1.615, 18.841],
                      [18.749, 36.059],
                      [35.883, 18.841],
                      [18.749, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -9.49],
                      [-9.45, 0],
                      [0, 9.49],
                      [9.45, 0],
                    ],
                    o: [
                      [-9.45, 0],
                      [0, 9.49],
                      [9.45, 0],
                      [0, -9.49],
                      [0, 0],
                    ],
                    v: [
                      [18.75, 1.62],
                      [1.61, 18.84],
                      [18.75, 36.06],
                      [35.88, 18.84],
                      [18.75, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 30,
      parent: 27,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0.81, 8.61] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [88.52, 90.28],
              t: 0,
            },
            { s: [96.35, 98.02], t: 75 },
          ],
        },
        r: { a: 0, k: -45.14 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.619, 0],
                      [0, 0],
                      [0, 17.212],
                      [1.619, 17.212],
                      [1.619, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.62, 0],
                      [0, 0],
                      [0, 17.21],
                      [1.62, 17.21],
                      [1.62, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 31,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [8.28, 0.81] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [37.28, 90.54],
              t: 0,
            },
            { s: [45.11, 98.28], t: 75 },
          ],
        },
        r: { a: 0, k: -45.14 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.563, 0],
                      [0, 0],
                      [0, 1.619],
                      [16.563, 1.619],
                      [16.563, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.56, 0],
                      [0, 0],
                      [0, 1.62],
                      [16.56, 1.62],
                      [16.56, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 32,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0.81, 8.09] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [37.17, 37.3],
              t: 0,
            },
            { s: [45, 45.03], t: 75 },
          ],
        },
        r: { a: 0, k: -45.14 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.619, 0],
                      [0, 0],
                      [0, 16.174],
                      [1.619, 16.174],
                      [1.619, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.62, 0],
                      [0, 0],
                      [0, 16.17],
                      [1.62, 16.17],
                      [1.62, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 33,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [15.54, 10.88],
              t: 0,
            },
            { s: [11.5, 8.5], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [140.54, 107.91],
              t: 0,
            },
            { s: [140.5, 107.5], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.151, 0.153],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.214, 0],
                    ],
                    o: [
                      [-0.213, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.151, 0.151],
                      [0, 0],
                    ],
                    v: [
                      [10.236, 21.762],
                      [9.665, 21.524],
                      [0, 11.811],
                      [1.141, 10.665],
                      [10.236, 19.804],
                      [29.943, 0],
                      [31.084, 1.147],
                      [10.806, 21.524],
                      [10.236, 21.762],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.11, 0.12],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.16, 0],
                    ],
                    o: [
                      [-0.16, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.11, 0.12],
                      [0, 0],
                    ],
                    v: [
                      [7.57, 17],
                      [7.15, 16.81],
                      [0, 9.23],
                      [0.84, 8.33],
                      [7.57, 15.47],
                      [22.16, 0],
                      [23, 0.9],
                      [8, 16.81],
                      [7.57, 17],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 34,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [29.51, 29.66] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [141, 106] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 16.355],
                      [-16.275, 0],
                      [0, -16.355],
                      [16.275, 0],
                    ],
                    o: [
                      [-16.275, 0],
                      [0, -16.355],
                      [16.275, 0],
                      [0, 16.355],
                      [0, 0],
                    ],
                    v: [
                      [29.514, 59.318],
                      [0, 29.659],
                      [29.514, 0],
                      [59.028, 29.659],
                      [29.514, 59.318],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 16.35],
                      [-16.27, 0],
                      [0, -16.35],
                      [16.27, 0],
                    ],
                    o: [
                      [-16.27, 0],
                      [0, -16.35],
                      [16.27, 0],
                      [0, 16.35],
                      [0, 0],
                    ],
                    v: [
                      [29.51, 59.32],
                      [0, 29.66],
                      [29.51, 0],
                      [59.03, 29.66],
                      [29.51, 59.32],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -15.459],
                      [-15.383, 0],
                      [0, 15.459],
                      [15.383, 0],
                    ],
                    o: [
                      [-15.383, 0],
                      [0, 15.459],
                      [15.383, 0],
                      [0, -15.459],
                      [0, 0],
                    ],
                    v: [
                      [29.514, 1.623],
                      [1.615, 29.659],
                      [29.514, 57.695],
                      [57.413, 29.659],
                      [29.514, 1.623],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -15.46],
                      [-15.38, 0],
                      [0, 15.46],
                      [15.38, 0],
                    ],
                    o: [
                      [-15.38, 0],
                      [0, 15.46],
                      [15.38, 0],
                      [0, -15.46],
                      [0, 0],
                    ],
                    v: [
                      [29.51, 1.62],
                      [1.61, 29.66],
                      [29.51, 57.7],
                      [57.41, 29.66],
                      [29.51, 1.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 35,
    },
  ],
  v: "5.7.0",
  fr: 60,
  op: 75.01,
  ip: 0,
  assets: [],
};
